module.exports = __webpack_public_path__ + "img/numCard-11.c7f75e4e.svg";